var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RenderEvent',{key:_vm.routeKey,attrs:{"event":this.$route.params.subPage || 'page',"only":this.$route.params.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }